"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var statusEnum = Object.freeze({
  INITIAL: 0,
  AWAITING: 1,
  REQUESTED: 2,
  ERROR: 3,
  SUCCESS: 4,
  RELOADING: 5
});
var _default = statusEnum;
exports["default"] = _default;